export const kioskListRowStyles = {
  btnDetails: {
    border: '1px solid #7c7c7c',
    fontSize: '11px'
  }
}
